import * as React from 'react';

function SvgInstallTanium(props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 113.1 92.3" ref={svgRef} {...props}>
      <ellipse cx={56.5} cy={75.5} fill="#e2e8ef" rx={56.5} ry={16.8} />
      <path d="M57.2 37.7v45.1l-34.7-12V25.4z" fill="#edf3fb" />
      <path
        d="M57.2 83.8c-.1 0-.2 0-.3-.1l-34.7-12c-.4-.1-.7-.5-.7-.9V25.4c0-.3.2-.6.4-.8.3-.2.6-.2.9-.1l34.7 12.4c.4.1.7.5.7.9v45.1c0 .3-.2.6-.4.8-.2 0-.4.1-.6.1zM23.5 70.1l32.7 11.3v-43L23.5 26.8z"
        fill="#646a7e"
      />
      <path d="M57.4 37.7v45.1l34.7-12V25.4z" fill="#edf3fb" />
      <path
        d="M57.4 83.8c-.2 0-.4-.1-.6-.2-.3-.2-.4-.5-.4-.8V37.7c0-.4.3-.8.7-.9l34.7-12.4c.3-.1.6-.1.9.1s.4.5.4.8v45.5c0 .4-.3.8-.7.9l-34.7 12c-.1.1-.2.1-.3.1zm1-45.3v43l32.7-11.3V26.8z"
        fill="#646a7e"
      />
      <path d="M59 36.6l5.7 9.4 33.8-12.8-6-8.8z" fill="#edf3fb" />
      <path
        d="M64.1 48c-.3 0-.7-.2-.9-.5l-5.7-9.4c-.2-.3-.2-.6-.1-.8.1-.3.3-.5.6-.6l34-12.2c.4-.2.9 0 1.2.4l6.1 8.8c.2.3.2.6.1.9s-.3.5-.6.6L64.5 48h-.4zm-4.2-9.9l4.7 7.7L97 33.7l-5-7.1z"
        fill="#646a7e"
      />
      <path d="M56.5 37.6L50.9 47 17.1 34.2l5.9-8.8z" fill="#edf3fb" />
      <path
        d="M50.1 48L16 35.1c-.3-.1-.5-.3-.6-.6s0-.6.1-.9l6-8.8c.3-.4.7-.5 1.2-.4l33.8 12.2c.3.1.5.3.6.6s.1.6-.1.8l-5.7 9.4c-.2.3-.5.5-.9.5 0 .1-.1.1-.3.1zM22.8 26.6l-4.9 7.1L50 45.8l4.6-7.7z"
        fill="#646a7e"
      />
      <path
        d="M82 67.6v-8l5.2-1.6c-.6 3.5-2.5 7-5.2 9.6zM72.5 59l.2 3.6 5.7-1.8.2 8.8c-.5.2-.9.4-1.4.6-5.5 1.8-10.5-1-11.3-6.7-.9-6.2 3.3-13.4 9.6-15.8 6.1-2.4 11.3.8 12 6.9z"
        fill="#ea3531"
      />
      <path
        d="M22.9 25.1L44 17.3M92.1 25.1l-21-7.8"
        fill="#fff"
        stroke="#646a7e"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
      />
      <g fill="#646a7e">
        <path d="M57.4 28.7c-1.1 0-2-.9-2-2V2c0-1.1.9-2 2-2s2 .9 2 2v24.7c0 1.1-.9 2-2 2z" />
        <path d="M58.5 27.9l-.2.2c-.7.7-1.9.7-2.6 0l-7.5-7.5c-.7-.7-.7-1.9 0-2.6l.2-.2c.7-.7 1.9-.7 2.6 0l7.5 7.5c.7.7.7 1.9 0 2.6z" />
        <path d="M56.1 27.9l.2.2c.7.7 1.9.7 2.6 0l7.5-7.5c.7-.7.7-1.9 0-2.6l-.2-.2c-.7-.7-1.9-.7-2.6 0l-7.5 7.5c-.7.7-.7 1.9 0 2.6z" />
      </g>
    </svg>
  );
}

const ForwardRef = React.forwardRef(SvgInstallTanium);
export default ForwardRef;
